import { render, staticRenderFns } from "./bwsuppressions.vue?vue&type=template&id=6a66c1a8&"
import script from "./bwsuppressions.vue?vue&type=script&lang=js&"
export * from "./bwsuppressions.vue?vue&type=script&lang=js&"
import style0 from "./bwsuppressions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports